import { WidgetFieldConfig } from '../core/domain/widget-field-config';

/**
 * Returns the catalog items whose option is selected, in catalog order.
 * Options are bound to the item objects themselves (`[value]="item"`), so
 * matching is by reference. Two items that share a name stay distinct, and
 * names with stray whitespace still match (itb-dashboard#1173, #1174).
 */
export function selectByReference(
  items: WidgetFieldConfig[] | null | undefined,
  selectedValues: unknown[],
): WidgetFieldConfig[] {
  const selected = new Set(selectedValues);
  return (items ?? []).filter((item) => selected.has(item));
}
